define('modules/editor/views/copypaste_popup',['require','exports','module','common/views/modal_view','../models/editorstate','ldsh!../templates/copypaste_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view"),
      EditorState = require("../models/editorstate");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/copypaste_popup"),
    triggers: {
      "click .js-ok": "copy",
      "click .js-cancel": "continue"
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  var retrieveForbiddenElement  = function(copiedElements) {
      var step = EditorState.getActivePage();
      return checkElementForm(copiedElements) && step.hasElement("element:form");
    },

    checkElementForm = function (copiedElements) {
      return !!_.find(copiedElements, function (copiedElement) {
        return copiedElement.name === "element:form";
      });
    };

  _.extend(module.exports, {
    show: function(copiedElements) {
      var defer = $.Deferred(),
          element  = retrieveForbiddenElement(copiedElements);
      if (element) {
        var popup = new module.exports();
        popup.on("copy", _.bind(defer.resolve, defer, element));
        popup.on("continue", _.bind(defer.reject, defer));
        defer.always(_.bind(popup.hide, popup));
      } else {
        defer.resolve();
      }
      return defer.promise();
    }
  });
});

